const track = require('../../../components/track').default

const roamingCalc = new Vue({
  el: '#roamingCalc',
  data() {
    return {
      origin: undefined,
      call: undefined,
      line: undefined,
      destination: undefined,
      options: {
        spain: {
          outgoing: {
            esp: {
              esp: "outNational",
              eur: "outNational",
              int: "outNational",
            },
            eur: {
              esp: "outInternational",
              eur: "outInternational",
              int: "outInternational",
            },
            int: {
              esp: "outInternational",
              eur: "outInternational",
              int: "outInternational",
            },
          },
          incoming: {
            esp: {
              esp: "inNational",
              eur: "inNational",
              int: "inNational",
            },
            eur: {
              esp: "inNational",
              eur: "inNational",
              int: "inNational",
            },
            int: {
              esp: "inNational",
              eur: "inNational",
              int: "inNational",
            },
          },
        },
        europe: {
          outgoing: {
            esp: {
              esp: "outRoamingEU",
              eur: "outRoamingEU",
              int: "outRoamingEU",
            },
            eur: {
              esp: "outRoamingEU",
              eur: "outRoamingEU",
              int: "outRoamingEU",
            },
            int: {
              esp: "outRoamingInt",
              eur: "outRoamingInt",
              int: "outRoamingInt",
            },
          },
          incoming: {
            esp: {
              esp: "inRoamingEU",
              eur: "inRoamingEU",
              int: "inRoamingEU",
            },
            eur: {
              esp: "inRoamingEU",
              eur: "inRoamingEU",
              int: "inRoamingEU",
            },
            int: {
              esp: "inRoamingEU",
              eur: "inRoamingEU",
              int: "inRoamingEU",
            },
          },
        },
        international: {
          outgoing: {
            esp: {
              esp: "outRoamingInt",
              eur: "outRoamingInt",
              int: "outRoamingInt",
            },
            eur: {
              esp: "outRoamingInt",
              eur: "outRoamingInt",
              int: "outRoamingInt",
            },
            int: {
              esp: "outRoamingInt",
              eur: "outRoamingInt",
              int: "outRoamingInt",
            },
          },
          incoming: {
            esp: {
              esp: "inRoamingInt",
              eur: "inRoamingInt",
              int: "inRoamingInt",
            },
            eur: {
              esp: "inRoamingInt",
              eur: "inRoamingInt",
              int: "inRoamingInt",
            },
            int: {
              esp: "inRoamingInt",
              eur: "inRoamingInt",
              int: "inRoamingInt",
            },
          },
        },
        cruise: {
          outgoing: {
            esp: {
              esp: "outSatellite",
              eur: "outSatellite",
              int: "outSatellite",
            },
            eur: {
              esp: "outSatellite",
              eur: "outSatellite",
              int: "outSatellite",
            },
            int: {
              esp: "outSatellite",
              eur: "outSatellite",
              int: "outSatellite",
            },
          },
          incoming: {
            esp: {
              esp: "inSatellite",
              eur: "inSatellite",
              int: "inSatellite",
            },
            eur: {
              esp: "inSatellite",
              eur: "inSatellite",
              int: "inSatellite",
            },
            int: {
              esp: "inSatellite",
              eur: "inSatellite",
              int: "inSatellite",
            },
          },
        },
      }
    }
  },
  created () {},
  mounted() {
    $(this.$el).addClass('loaded')
  },
  computed: {
    isSpain: function() {
      return this.origin == "spain"
    },
    isEurope: function() {
      return this.origin == "europe"
    },
    isInternational: function() {
      return this.origin == "international"
    },
    isCruise: function() {
      return this.origin == "cruise"
    },

    isEspEsp: function() {
      return this.line == "esp" && this.destination == "esp"
    },
    isEspEur: function() {
      return this.line == "esp" && this.destination == "eur"
    },
    isEspInt: function() {
      return this.line == "esp" && this.destination == "int"
    },
    isEurEsp: function() {
      return this.line == "eur" && this.destination == "esp"
    },
    isEurEur: function() {
      return this.line == "eur" && this.destination == "eur"
    },
    isEurInt: function() {
      return this.line == "eur" && this.destination == "int"
    },
    isIntEsp: function() {
      return this.line == "int" && this.destination == "esp"
    },
    isIntEur: function() {
      return this.line == "int" && this.destination == "eur"
    },
    isIntInt: function() {
      return this.line == "int" && this.destination == "int"
    },

    type: function () {
      if(!this.optionsSelected)
        return false

      return this.options[this.origin]
                        [this.call]
                        [this.line]
                        [this.destination]
    },

    optionsSelected: function(){
      if (!this.origin || !this.call || !this.line || !this.destination)
        return false
      else
        return true
    },

    somethingSelected: function(){
      if (this.origin || this.call || this.line || this.destination)
        return true
      else
        return false
    }

  },
  methods: {
    trackSelection: function() {
      if(this.optionsSelected){
        track.event({
            eventAction: "Roaming Calculator",
            eventCategory: "Option selected",
            eventLabel: "origin:"+this.origin+" call:"+this.call+" line:"+this.line+" destination:"+this.destination+" rate:"+this.type
          })
      }

    }
  }
})
